function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0005 27C23.5288 27 24.8675 26.4669 25.9456 25.2822C26.5735 24.5832 26.9645 23.7658 26.9645 22.9602C26.9645 22.3678 26.7394 21.7991 26.1826 21.3963L22.5455 18.8137C21.9887 18.4346 21.5267 18.245 21.1002 18.245C20.567 18.245 20.0813 18.553 19.5363 19.0862L18.6952 19.9155C18.5649 20.0458 18.399 20.105 18.245 20.105C18.0673 20.105 17.8896 20.0339 17.7711 19.9747C17.0366 19.5837 15.7808 18.5057 14.608 17.3446C13.447 16.1836 12.3689 14.9278 11.9898 14.1933C11.9305 14.063 11.8595 13.8971 11.8595 13.7194C11.8595 13.5654 11.9068 13.4114 12.0372 13.2811L12.8783 12.4163C13.3996 11.8713 13.7194 11.3974 13.7194 10.8525C13.7194 10.426 13.518 9.96392 13.1271 9.40711L10.58 5.81745C10.1653 5.24879 9.58481 5 8.94507 5C8.16317 5 7.35757 5.35541 6.65859 6.03069C5.50942 7.13247 5 8.49488 5 9.99946C5 13.3996 7.59451 17.5223 11.0183 20.9343C14.4421 24.3581 18.6004 27 22.0005 27Z",
  fill: "#F5F6F6"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.13e053fa.svg";
export { ForwardRef as ReactComponent };